import React , {Component} from 'react'
import {Divider , Icon} from 'antd'
import axios from 'axios';

export default class Feed extends Component{
    constructor(props){
        super(props);
        this.state = {
            isLoading : true,
            feedItems : [],
            feedInfo : []
        }
    }
    componentDidMount(){
        axios.get(this.props.rss)
          .then( response => {
            if(response.status == 200){
                this.setState({
                    feedItems : response.data.items ,
                    feedInfo : response.data.feed ,
                   isLoading : false
                }) 
                console.log('res is :' , this.state.feedItems );
            }
          })
          .catch(function (error) {
              console.log("error is : " , error)
          });
    }
    render(){
        return(
                <div className="pageTitle1Wrapper">
                    <div className="certificatesCard">
                        <div className="certificatesCardInner">
                            <div className="pageTitle1Wrapper">
                                <div className="pageTitle1">
                                    <div className="newsSourseIcon">
                                        <img src={this.props.logo} alt=""/>
                                    </div>
                                    <h2>{this.props.title}</h2>
                                </div>
                            </div>
                            <Divider/>
                            <div className="feedContentWrapper">
                                {
                                    this.state.isLoading ? 
                                    (
                                        <div className="tableLoadingWrapper">
                                            <div>
                                                <Icon type="sync" spin />
                                            </div>
                                            <p>در حال بارگیری ...</p>
                                        </div>
                                    ):
                                    (
                                        this.state.feedItems.map(function(item , index){
                                            return(
                                                <a href={item.link} target={"_blank"} className={item.thumbnail ? ("feedItem") : ("feedItemNoImg")} key={index}>
                                                    <div className="feedItemImg" style={{ display : item.thumbnail ? ('block') : ('none')}}>
                                                        <img src={item.thumbnail}/>
                                                    </div>
                                                    <div className={item.thumbnail ? ("feedTitle") : ("feedTitleNoImg")}>
                                                        <p>
                                                            {item.title}
                                                        </p>
                                                    </div>
                                                </a>
                                            )
                                        })
                                    )
                                }
                            </div>
                        </div>
                    </div>
                </div>
        )
    }
}